import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {IIntegrationLogSearchDto} from '@app/logic/integration-logs';

interface IData {
    log: IIntegrationLogSearchDto;
}

@Component({
    templateUrl: './exception-log-view-dialog.component.html',
    styleUrls: ['./exception-log-view-dialog.component.scss'],
    standalone: false
})
export class ExceptionLogViewDialogComponent {
    public static readonly MIN_WIDTH = '40%';

    public details: string[];

    constructor(
        public readonly dialogRef: MatDialogRef<ExceptionLogViewDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: IData
    ) { }


    public close(): void {
        this.dialogRef.close();
    }
}
